import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DropdownMenuArrow } from "@radix-ui/react-dropdown-menu";
import { EllipsisVertical } from "lucide-react";

type OptionMenuProps = {
  error?: boolean;
  handleResend?: () => void;
  handleDelete?: () => void;
};

const OptionMenu = ({ error, handleResend, handleDelete }: OptionMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="transition-opacity opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100">
          <EllipsisVertical
            size={24}
            className="hover:text-gray-600 text-gray-400 cursor-pointer"
          />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" className="w-fit overflow-hidden">
        <DropdownMenuLabel>Message Options</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {error && (
          <DropdownMenuItem onClick={handleResend}>
            Resend Message
          </DropdownMenuItem>
        )}
        <DropdownMenuLabel className="text-neutral-500 font-normal" onClick={handleDelete}>
          Delete Message (disabled)
        </DropdownMenuLabel>
        <DropdownMenuArrow
          className="-my-px border-none fill-popover drop-shadow-[0_1px_0_#d6dee6]"
          width={12}
          height={7}
          aria-hidden="true"
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default OptionMenu;
